export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_02.8c478482.jpg";